import React from 'react';
import {EconomicActivitySriInterface} from "../../../services/interface/sri/economic-activity-sri-interface";
import Activity from "./Activity";

interface Props {
    nivel?: number;
    economicActivity?: EconomicActivitySriInterface | null;
    children?: React.ReactNode;
}
export default function RenderEconomicActivityTree({nivel  = 1, economicActivity}: Props) {
    if (!economicActivity) return null;

    return (
        <>
            <Activity nivel={nivel} economicActivity={economicActivity} />

            {economicActivity.economicActivityFather && (
                <RenderEconomicActivityTree
                    economicActivity={economicActivity.economicActivityFather}
                    nivel={nivel + 1}
                />
            )}
        </>
    );
}
